import { Epic } from 'redux-observable'
import { combineLatest } from 'rxjs'
import { filter, map } from 'rxjs/operators'

import { initializeWebSocket, receiveSocketConnection, socketSetupSuccess } from '@driftt/drift-ws'
import { GlobalStore } from '@driftt/traffic-control'

import { isActionOf, RootAction, RootState, Services } from 'typesafe-actions'

import { getHasPushCluster } from '../gates/selectors'

export const initWebsocketsEpic: Epic<any, RootAction, RootState, Services> = (action$) =>
  combineLatest([
    action$.pipe(filter((action) => action.type === 'RECEIVE_USER_CONFIG')),
    action$.pipe(filter(isActionOf(receiveSocketConnection))),
  ]).pipe(
    map(([bootstrapSuccessAction]) => {
      const hasPushCluster = getHasPushCluster()
      initializeWebSocket(bootstrapSuccessAction.config.orgId, GlobalStore, hasPushCluster)
      return socketSetupSuccess()
    })
  )
